import { TenDlcDetails } from './_types';

export const hasStarted10Dlc = (details: {
  twilio10dlcStatus?: string | null;
}): boolean => {
  return !!details?.twilio10dlcStatus;
};

/**
 * Show SMS opt-in checkbox and compliance copy only when SMS is live or the
 * platform has a 10DLC registration in progress (status present after submit).
 */
export const shouldShowSmsOptInComplianceUi = (session: {
  smsAvailable?: boolean;
  twilio10dlcStatus?: string | null;
} | null | undefined): boolean => {
  if (!session) return false;
  if (session.smsAvailable) return true;
  return hasStarted10Dlc(session);
};

/** Matches Rails `!user.sms_opted_out?` — only explicit true means opted out. */
export const isSmsOptedIn = (smsOptedOut?: boolean | null): boolean =>
  smsOptedOut !== true;

export const isAwaiting10DlcBrandApproval = (
  details: TenDlcDetails
): boolean => {
  return details.twilio10dlcStatus === 'awaiting_brand_approval';
};

export const isAwaiting10DlcCampaignApproval = (
  details: TenDlcDetails
): boolean => {
  return details.twilio10dlcStatus === 'awaiting_campaign_approval';
};

export const isAwaiting10DlcNumberApproval = (
  details: TenDlcDetails
): boolean => {
  return details.twilio10dlcStatus === 'awaiting_phone_number_approval';
};

export const is10DLCApproved = (details: TenDlcDetails): boolean => {
  return details.twilio10dlcStatus === 'approved';
};
